export enum Locales {
  EN = 'en',
  ES = 'es',
}

export const LOCALES = [
  { value: Locales.EN, caption: 'EN' },
  { value: Locales.ES, caption: 'ES' }
]
